import catalog from './catalog';
import productManage from './_admin-product-manage';
import userManager from './_admin-user-manage';
import organizationManager from './_admin-organization-manage';

export default {
  catalog,
  productManage,
  userManager,
  organizationManager,
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/index.js